import { render, staticRenderFns } from "./FowDepositCard.vue?vue&type=template&id=2abec1f0&scoped=true&lang=pug"
import script from "./FowDepositCard.vue?vue&type=script&lang=js"
export * from "./FowDepositCard.vue?vue&type=script&lang=js"
import style0 from "./FowDepositCard.vue?vue&type=style&index=0&id=2abec1f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abec1f0",
  null
  
)

export default component.exports